import React from "react";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";

import Sortable from "../../../../componets/Sortable";
import { reorderAvatars } from "../../../../actions/mine_craft/avatarsActions";

const Reorder = () => {
  const dispatch = useAppDispatch();
  const reorderIds = useAppSelector(state => state.mineCraft.avatars.reorderIds);
  const avatars = useAppSelector(state => state.mineCraft.avatars.entities);

  function onClickSave(ids: any[]) {
    dispatch(reorderAvatars({ ids }));
  }

  return (
    <div className='v-avatars-reorder'>
      <h6 className="v-content-label o-sm">Reorder</h6>

      {
        reorderIds &&
          <Sortable
            ids={reorderIds}
            onClickSave={onClickSave}
            imageKey={'image_url'}
            items={avatars}
            titleKey='name'
          />
      }
    </div>
  )
}

export default Reorder;
